import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, isRef as _isRef, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "reaction-select-list"
}
const _hoisted_2 = {
  key: 0,
  class: "reaction-select-list"
}

import {ConfigStore} from "~/chat/ts/store/Config";
import ChatModalMessage from "~/chat/vue/widget/ChatModalMessage.vue";
import ChatPopover from "~/chat/vue/misc/ChatPopover.vue";
import {setMessageReaction} from "~/chat/ts/service/messages/setMessageReaction";
import MessageWrapper from "~/chat/ts/data/chat/MessageWrapper";
import {ref} from "vue";
import ChatMessageReactionSelectorEmoji
    from "~/chat/vue/widget/tabs/chat/Reaction/ChatMessageReactionSelectorEmoji.vue";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "ChatMessageReactionSelector"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    message: {},
    popover: { type: Boolean }
  }, {
    "visible": { type: Boolean },
    "visibleModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["selected"], ["update:visible"]),
  setup(__props: any, { emit: __emit }) {

let props = __props;
let visible = _useModel<boolean>(__props, "visible");

let emits = __emit;

let showEmojiModal = ref(false);

function openEmojiModal() {
    visible.value = false;
    showEmojiModal.value = true;
}


async function setReaction(emoji?: string) {
    visible.value = showEmojiModal.value = false;
    setMessageReaction(props.message, emoji);
    emits("selected");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.popover ? ChatPopover : 'div'), {
      visible: _unref(visible),
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (_isRef(visible) ? (visible).value = $event : visible = $event)),
      "show-close-in-footer": false,
      fixed: "",
      class: _normalizeClass({'emoji-popover': _ctx.popover})
    }, {
      default: _withCtx(() => [
        (_unref(visible) || !_ctx.popover)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ConfigStore).siteParams.value.params.messageReactions.slice(0, 6), (emoji) => {
                return (_openBlock(), _createBlock(ChatMessageReactionSelectorEmoji, {
                  emoji: emoji,
                  onClick: ($event: any) => (setReaction(emoji))
                }, null, 8, ["emoji", "onClick"]))
              }), 256)),
              _createVNode(ChatMessageReactionSelectorEmoji, {
                more: "",
                onClick: openEmojiModal
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 40, ["visible", "class"])),
    _createVNode(ChatModalMessage, {
      visible: _unref(showEmojiModal),
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_isRef(showEmojiModal) ? (showEmojiModal).value = $event : showEmojiModal = $event)),
      "show-close-in-footer": false
    }, {
      default: _withCtx(() => [
        (_unref(showEmojiModal))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ConfigStore).siteParams.value.params.messageReactions, (emoji) => {
                return (_openBlock(), _createBlock(ChatMessageReactionSelectorEmoji, {
                  emoji: emoji,
                  onClick: ($event: any) => (setReaction(emoji))
                }, null, 8, ["emoji", "onClick"]))
              }), 256))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})